import {getPrivateAxios} from '../../libs';

export interface UserUpdateDto {
  email?: string;
  fullName?: string;
}

export const fetchUserSelfUpdate = async (userUpdateDto: UserUpdateDto) => {
  const {data} = await getPrivateAxios().patch<{accessToken: string}>('/users/self', userUpdateDto);
  return data;
};
